import React from "react";
import DockmanagerFormPageContainer from "./DockmanagerFormPageContainer";

export class DockmanagerFormPage extends React.Component {
  render() {
    return <DockmanagerFormPageContainer {...this.props} />;
  }
}
